export const removeSpecialCharacters = (stringToClean: string) =>
  stringToClean.replace(/[^a-zA-Z0-9]/g, '');
